export default __webpack_public_path__ + "static/android-chrome-384x384.png";